@if (selectedJobType?.name) {
  <ng-container>
    <!-- Other Job Type Section -->
    @if (![0, 4, 5].includes(selectedJobType?.type_identity)) {
      <gtapp-other [selectedJobType]="selectedJobType"></gtapp-other>
    }
    <!-- Response Job Type Section -->
    @if (selectedJobType?.type_identity === 0) {
      <gtapp-response [selectedJobType]="selectedJobType"> </gtapp-response>
    }
    <!-- Casual Patrol Job Type Section -->
    @if (selectedJobType?.type_identity === 5) {
      <gtapp-casual-patrol [selectedJobType]="selectedJobType">
      </gtapp-casual-patrol>
    }
    <!-- Patrol Job Type Section -->
    @if (selectedJobType?.type_identity === 4) {
      <gtapp-patrol [selectedJobType]="selectedJobType"> </gtapp-patrol>
    }
  </ng-container>
} @else {
  <ng-container>
    @if (jobTypes?.length) {
      <div class="p-1 fw-semibold mb-2">Select Job Type</div>
      <div class="d-flex flex-column gap-4 col-lg-4">
        @for (jobType of jobTypes; track jobType) {
          <div
            (click)="changeJobType(jobType)"
            role="button"
            class="rounded p-4 text-center hover fs-4 bg-primary border boder-primary"
          >
            {{ jobType?.name }}
          </div>
        }
      </div>
    } @else {
      <div class="alert alert-warning">
        You don't have permission to perform this action
      </div>
    }
  </ng-container>
}
